import { render } from "./FloatingChat.vue?vue&type=template&id=10db226d&scoped=true"
import script from "./FloatingChat.vue?vue&type=script&lang=js"
export * from "./FloatingChat.vue?vue&type=script&lang=js"

import "./FloatingChat.vue?vue&type=style&index=0&id=10db226d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10db226d"]])

export default __exports__